import React, { useEffect, useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
import { SearchInput } from "../search/SearchInput";
import { CustomLoading, CustomNoRowsOverlay} from "../utils/tableComponents";
import { Grid } from "@material-ui/core";
import clsx from "clsx";
import { CustomFilters } from "../search/CustomFilters";
import { useDataProvider } from "../../api/DataProvider";
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import { formatHistoryDate } from '../../api/utils/strings';
import { useTranslation } from "react-i18next";

import "../../styles/devices/mob_SignsTable.css";

/* MOB - Is it neccesary to export this function? It doesn't seem to be used anywhere else. 
  I assume it doesn't really have an impact, but I leave this comment to check it in the future just in case.
*/
export function AddIcon(params) {
  /* Black already seems to be the default color, so we just need classes for the desired states */
  return <SignLanguageIcon className={`sig_ST_SignIcon${ params.row.accesible }`} />;
}

export function HistoryTable(props) {
  const { showDialog } = props;
  const { t } = useTranslation("global")
  
  const { getListNameDefinitionsDate, json_data_USER } = useDataProvider();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);


  const columns = [
    { field: "accesible", headerName: "", width: 50, renderCell: (params) => AddIcon(params) },
    { field: "name", headerName: t("sTable.name"), width: 200 },
    { field: "definition", headerName: t("sTable.definition"), flex: 1 },
    { field: "date", headerName: t("sTable.date"), width: 200, renderCell: (params) => formatHistoryDate(params.row.date)},
  ];

  /* Sorting, Filtering and Legend */
  const [filterMenuActive, setFilterMenuActive] = useState(false);
  // const [legendMenuActive, setLegendMenuActive] = useState(false);
  const [sortModel, setSortModel] = useState([{ field: "date", sort: "desc" }]);
  const [filterState, setFilterState] = useState([
    true, // orderAsc
    false, // orderDesc
    true, // showTerm
    true, // showDef
    true, // showAccGreen
    true, // showAccYellow
    true, // showAccRed
    false, // complexSearch
  ]);

  useEffect(() => {
    const arr_history = json_data_USER['session']['arr_history']
    let r = getListNameDefinitionsDate(arr_history);
    setRows(r);
    setFilteredRows(r);
    setLoading(false);
  }, [json_data_USER]);

  /* Click cell */
  function handleRowClick(params, event) {
    try {
      showDialog([rows[params.id]["_id"]]);
    } catch(err){
      console.error(err)
    }
  }

  function handleSearch(e) {
    const search = e.target.value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    var fr = [];
    rows.forEach((i) => {
      try {
        if (
          i["name"]
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .startsWith(search)
        ) {
          fr.push(i);
        } else if ((filterState[7] === true) && (
          i["definition"][0]
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .includes(search)
          )) {
            fr.push(i);
          }
      } catch {}
    });
    setFilteredRows(fr);
  }

  /* Pagination */
  function handlePageSizeChange(params) {
    setPageSize(params.pageSize);
  }

  const handleFilterOptions = (event, filterId, newFilterState) => {
    if (filterId <= 1) {
      if (sortModel[0]['sort'] === 'asc') {
        setSortModel([{ field: "name", sort: "desc" }]);
      } else {
        setSortModel([{ field: "name", sort: "asc" }]);
      }
    }
    setFilterState(newFilterState);
  };

  function handleFilterMenu() {
    setFilterMenuActive((state) => !state);
  }

  /*function handleLegendMenu() {
    setLegendMenuActive((state) => !state);
  }*/

  return (
    <div className="sig_ST_Root">
      <Grid container direction="column">
        <div className={`sig_ST_CustomFilters_MenuBkg ${filterMenuActive ? "" : "sig_ST_CustomFilters_MenuBkg_Hidden"}`} onClick={handleFilterMenu}></div>
        <Grid item className="sig_SignsDB_SearchContainer">
          <SearchInput disabled={loading} handleSearch={handleSearch} />    
          {props.children} 
        </Grid>
        <div style={{width: '90%' , margin: "40px auto 20px"}} >
          <Grid item>
            <DataGrid
              className={clsx("sig_History_Datagrid", {
                sig_ST_HiddenTerm: !filterState[2],
                sig_ST_HiddenDef: !filterState[3],
                sig_ST_HiddenAccGREEN: !filterState[4],
                sig_ST_HiddenAccYELLOW: !filterState[5],
                sig_ST_HiddenAccRED: !filterState[6],
              })}
              autoHeight
              getRowClassName={(params) => `sig_ST_HiddenAcc${params.getValue(params.id, 'accesible')}`}
              pageSize={pageSize}
              onPageSizeChange={handlePageSizeChange}
              rowsPerPageOptions={[10, 25, 50, 100]}
              pagination
              disableSelectionOnClick
              sortModel={sortModel}
              loading={loading}
              columns={columns}
              rows={filteredRows}
              onRowClick={handleRowClick}
              components={{
                LoadingOverlay: CustomLoading,
                NoRowsOverlay: CustomNoRowsOverlay
                /* Toolbar: CustomToolbar */
              }}
            />
          </Grid>
        </div>
      </Grid>
      <CustomFilters active={filterMenuActive} handleFilterOptions={handleFilterOptions} handleFilterMenu={handleFilterMenu} />
    </div>
  );
}
